import {request_async} from "@/utils/requestAsync";
import {API_URL_ERP} from "@/model/ConfigModel";

// todo 改用exp提供接口，或生成统一token验证，保证安全性

// 新增修改
export async function addOrEdit(platformId, data) {
  return request_async(API_URL_ERP + "/v1/feedback/?platformId=" + platformId, "post_body", data);
}
